const isValidHeight = (height) => {
    if (height) {
        const feet = height.split('ft')[0].trim();
        const inches = height.split('ft')[1].split('in')[0].trim();
        if (feet > 0 && inches >= 0 && inches !== "") {
            return true;
        } 
            return false;
        
    }
    return false;
};

const isValidWeight = (weight) => {
    const wts = parseInt(weight);
    if (weight && wts >= 78 && wts <= 395) {
        const wt = weight.split(' ')[0].trim();
        if (wt) {
            return true;
        } 
            return false;
        
    }
    return false;
};

const isHeightInRange = (height, minInch = 12, maxInch = null) => {
    if (!height || typeof height !== "string") { return false; }

    const heightRegex = height.match(/(\d+)\s*ft\s*(\d*)\s*in*/);
    if (!heightRegex) { return false; }

    const feet = Number(heightRegex[1]);
    const inches = Number(heightRegex[2] || 0);
    const heightInInches = (feet * 12) + inches;

    return heightInInches <= minInch || (maxInch && heightInInches >= maxInch);
};

const isWeightInRange = (weight, minWeight = 78, maxWeight = 395) => {
    if (!weight || typeof weight !== "string") { return false; }

    const weightRegex = weight.match(/(\d+)/);
    if (!weightRegex) { return false; }

    const weightInLbs = Number(weightRegex[1]);

    return weightInLbs <= minWeight || weightInLbs >= maxWeight;
};

export { isValidHeight, isValidWeight, isHeightInRange, isWeightInRange };
